// Small constants the always-loaded shell needs (header search hint, footer category links), kept apart from
// the full tool registry (src/data/tools.ts: icons and every tool's text) so the registry stays out of the core
// bundle. tests/unit/registryPlain.test.ts fails if these drift from the registry.
export const TOOL_COUNT = 284;

/** The category hub pages (full text and membership: src/data/hubs.ts, which stays out of the core bundle). */
export const HUB_LINKS = [
  { path: '/json-tools', label: 'JSON tools' },
  { path: '/converters', label: 'Converters' },
  { path: '/security-tools', label: 'Security tools' },
  { path: '/frontend-tools', label: 'Frontend tools' },
  { path: '/data-tools', label: 'Data tools' },
  { path: '/devops-tools', label: 'DevOps tools' },
  { path: '/pdf-tools', label: 'PDF tools' },
  { path: '/playground-tools', label: 'Playgrounds' },
  { path: '/image-tools', label: 'Image tools' },
] as const;

/** The image tools, in the order the Image tools hub and the menu section show them. They stay in their own categories too (nothing moves, no URL changes). */
export const IMAGE_TOOL_PATHS = [
  '/image-compressor',
  '/image-resizer',
  '/image-cropper',
  '/image-to-webp',
  '/svg-to-png',
  '/svg-optimizer',
  '/image-base64',
  '/base64-to-image',
  '/exif-remover',
  '/favicon-generator',
  '/placeholder-image',
  '/code-to-image',
  '/image-color-extractor',
  '/images-to-pdf',
  '/image-to-text',
  '/scan-to-pdf',
  '/pdf-to-jpg',
  '/pdf-to-svg',
] as const;

/** The hub each registry category is shown under in All tools. */
export const CATEGORY_HUB: Record<string, string> = {
  'Formatters & Parsers': '/json-tools',
  'Security & Auth': '/security-tools',
  'Code & Conversion': '/converters',
  'Frontend & Design': '/frontend-tools',
  'Data Generation & Utilities': '/data-tools',
  'DevOps & Network': '/devops-tools',
  'PDF & Documents': '/pdf-tools',
  Playground: '/playground-tools',
};

export const CATEGORY_NAMES = [
  'Formatters & Parsers',
  'Security & Auth',
  'Code & Conversion',
  'Frontend & Design',
  'Data Generation & Utilities',
  'DevOps & Network',
  'PDF & Documents',
  'Playground',
] as const;
